/**
 * CDA request + template status — single source of truth.
 */

import { createStatusHelpers } from "./statusHelpers";

export const CDA_STATUS = {
  DRAFT: "Draft",
  SENT: "Sent",
  VIEWED: "Viewed",
  SIGNED: "Signed",
  REJECTED: "Rejected",
  EXPIRED: "Expired",
  CLARIFICATION_PENDING: "Clarification Pending",
  DELETED: "Deleted",
} as const;

export type CdaStatus = (typeof CDA_STATUS)[keyof typeof CDA_STATUS];

const cdaHelpers = createStatusHelpers(CDA_STATUS, CDA_STATUS.DRAFT);

export const CDA_STATUS_VALUES = cdaHelpers.VALUES;
export const tryNormalizeCdaStatus = cdaHelpers.tryNormalize;
export const normalizeCdaStatus = cdaHelpers.normalize;
export const isCdaStatus = cdaHelpers.isStatus;
export const isAnyCdaStatus = cdaHelpers.isAnyStatus;

export const CDA_TEMPLATE_STATUS = {
  ACTIVE: "Active",
  DRAFT: "Draft",
  ARCHIVED: "Archived",
} as const;

export type CdaTemplateStatus =
  (typeof CDA_TEMPLATE_STATUS)[keyof typeof CDA_TEMPLATE_STATUS];

const templateHelpers = createStatusHelpers(
  CDA_TEMPLATE_STATUS,
  CDA_TEMPLATE_STATUS.DRAFT,
);

export const CDA_TEMPLATE_STATUS_VALUES = templateHelpers.VALUES;
export const tryNormalizeCdaTemplateStatus = templateHelpers.tryNormalize;
export const normalizeCdaTemplateStatus = templateHelpers.normalize;
export const isCdaTemplateStatus = templateHelpers.isStatus;
export const isAnyCdaTemplateStatus = templateHelpers.isAnyStatus;
